import { successMessage } from 'hooks/helpers';
import api from './api';

const BASE_URL = '/inputs';

class InputsService {
  constructor() {
    this.httpClient = api;
  }

  mappedJsonData(payload) {
    return payload.map((item) => ({
      ciclo: Number(item.Ciclo),
      viveiro: item.Viveiro,
      data: item['Data de Inserção'],
      hora: item.Hora,
      insumo: item.Insumos,
      quantidade: Number(item.Quantidade),
    }));
  }

  async inputsList(idCycle) {
    const response = await (await api.get(`${BASE_URL}/cycle-code/${idCycle}`)).data;
    return response;
  }

  async importData(payload) {
    try {
      const jsonData = this.mappedJsonData(payload);
      const { status, data } = await this.httpClient.post(`${BASE_URL}/import`, jsonData);

      const { importedData, errors } = data;

      return {
        status,
        importedData,
        errorsData: errors,
        successMessage: successMessage(importedData.length, jsonData.length),
      };
    } catch (err) {
      const errorMessage = err.response?.data?.message;
      throw new Error(errorMessage);
    }
  }
}

export default new InputsService();
